// src/constants/number/number.ts
var UNIT_ABBREVIATIONS = ["K", "M", "B", "T"];

export {
  UNIT_ABBREVIATIONS
};
